import {ADS_LOADER_PROD, ADS_LOADER_DEVELOPMENT} from '../constants';

const AD_BLOCK_TEST_ID = 'ad-block-test';

const getAdsLoaderConfig = (env) => {
    if (env === 'development') {
        return ADS_LOADER_DEVELOPMENT;
    }

    return ADS_LOADER_PROD;
};

const addScript = (props) => {
    const script = document.createElement('script');
    Object.entries(props).forEach(([key, value]) => script[key] = value);
    document.body.appendChild(script);
    return script;
}

export const insertAdBlockTestScript = (props = {}) => {
    const config = getAdsLoaderConfig(process.env.NODE_ENV);
    const adBlockTestIdScript = document.getElementById(AD_BLOCK_TEST_ID);
    if (!adBlockTestIdScript) {
        addScript({
            src: config.adBlockTest,
            id: AD_BLOCK_TEST_ID,
            ...props
        });
    }
}

export const insertAdsLoaderScripts = () => {
    const {adsLoader} = getAdsLoaderConfig(process.env.NODE_ENV);
    adsLoader.forEach((asset) => {
        const script = document.getElementById(asset.id);
        if (!script) {
            addScript(asset);
        }
    });
}


export const removeMesoScripts = () => {
    const {adsLoader} = getAdsLoaderConfig(process.env.NODE_ENV);
    const ids = adsLoader.map((asset) => {
        return asset.id;
    }).concat(AD_BLOCK_TEST_ID);
    ids.forEach((id) => {
        const script = document.getElementById(id);
        if (script) {
            script.remove();
        }
    });
}
